export const getEnvironment = url => {
  if (typeof window !== 'undefined' && window.location) {
    return window.location.hostname.includes('frontend-qa-1.auto1-test.com') ? `${url}__latest/` : url;
  }
  return url;
};